// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"56b56215","847":"fcb3744e"}[chunkId] + ".chunk.js";
};